var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import * as yup from "yup";
import axios, { AxiosError } from "axios";
import styled from "styled-components";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../components/Elements/Button";
import { PasswordValidator, buildLowercaseValidation, buildMatchValidation, buildMinLengthValidation, buildNumberValidation, buildSpecialCharacterValidation, buildUppercaseValidation, } from "../../components/Elements/PasswordValidator";
export var ResetPassword = function (_a) {
    var username = _a.username, token = _a.token, csrfToken = _a.csrfToken, passwordRequirementsJSON = _a.passwordRequirementsJSON, rolloutNewPasswordFieldFlag = _a.rolloutNewPasswordFieldFlag;
    var _b = useState([]), errors = _b[0], setErrors = _b[1];
    var _c = useState(""), password = _c[0], setPassword = _c[1];
    var _d = useState(""), confirmPassword = _d[0], setConfirmPassword = _d[1];
    var _e = useState(false), submitting = _e[0], setSubmitting = _e[1];
    var _f = useState(false), resetSuccessful = _f[0], setResetSuccessful = _f[1];
    var _g = useState(false), validForm = _g[0], setValidForm = _g[1];
    var _h = useState(false), seePassword = _h[0], setSeePassword = _h[1];
    // TODO:new-pass-GA: delete the confirm password field
    var validationSchema = yup.object().shape(__assign({ password: yup.string().required("Password is required") }, (!rolloutNewPasswordFieldFlag && {
        confirmPassword: yup
            .string()
            .oneOf([yup.ref("password"), null], "Passwords must match")
            .required("Confirm Password is required"),
    })));
    var renderHeader = function () {
        return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "d-flex flex-center mb-10" }, { children: _jsx("a", __assign({ href: "/" }, { children: _jsx("img", { src: "/assets/images/document-crunch-logo.jpg", className: "h-200px", alt: "" }) })) })), _jsx("h3", __assign({ className: "text-center font-weight-bolder" }, { children: "Set your new password" })), _jsx("p", __assign({ className: "text-center mb-5 text-muted font-weight-bold" }, { children: username }))] }));
    };
    var onFormSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, validationSchema.validate({
                            password: password,
                            confirmPassword: confirmPassword,
                        })];
                case 2:
                    _a.sent();
                    formData = new FormData(e.target);
                    if (rolloutNewPasswordFieldFlag) {
                        // add the confirm password to the form data
                        formData.append("resetting_form[plainPassword][second]", formData.get("resetting_form[plainPassword][first]"));
                    }
                    return [4 /*yield*/, axios.post("/resetting/reset/".concat(token), formData)];
                case 3:
                    _a.sent();
                    setResetSuccessful(true);
                    return [3 /*break*/, 6];
                case 4:
                    e_1 = _a.sent();
                    if (e_1 instanceof yup.ValidationError) {
                        setErrors(e_1.errors);
                    }
                    else if (e_1 instanceof AxiosError) {
                        setErrors(e_1.response.data.errors);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var renderPasswordRequirements = function () {
        var passwordRequirements = JSON.parse(passwordRequirementsJSON);
        var validationRules = [];
        if (passwordRequirements["MinimumLength"]) {
            validationRules.push(buildMinLengthValidation(passwordRequirements["MinimumLength"]));
        }
        if (passwordRequirements["RequireUppercase"]) {
            validationRules.push(buildUppercaseValidation());
        }
        if (passwordRequirements["RequireLowercase"]) {
            validationRules.push(buildLowercaseValidation());
        }
        if (passwordRequirements["RequireNumbers"]) {
            validationRules.push(buildNumberValidation());
        }
        if (passwordRequirements["RequireSymbols"]) {
            validationRules.push(buildSpecialCharacterValidation());
        }
        // TODO:new-pass-GA: delete this
        if (!rolloutNewPasswordFieldFlag) {
            validationRules.push(buildMatchValidation());
        }
        return (_jsx(PasswordValidator, { password: password, confirmPassword: confirmPassword, validationRules: validationRules, onValidate: function (isValid) {
                setValidForm(isValid);
            } }));
    };
    var renderForm = function () {
        return (_jsx("div", __assign({ className: "" }, { children: _jsx("form", __assign({ name: "resetting_form", method: "post", onSubmit: onFormSubmit, id: "dc-reset-form", className: "nucleos_user_resetting_reset" }, { children: _jsxs("div", __assign({ id: "resetting_form" }, { children: [_jsxs("div", __assign({ className: "form-group row flex-center position-relative" }, { children: [_jsx("input", { type: seePassword ? "text" : "password", name: "resetting_form[plainPassword][first]", onChange: function (e) { return setPassword(e.target.value); }, required: true, autoComplete: "new-password", className: "col-8 form-control h-auto form-control-solid py-4 px-8", "aria-autocomplete": "list", placeholder: "New password" }), rolloutNewPasswordFieldFlag && (_jsx(ShowPasswordDiv, __assign({ className: "input-group-append position-absolute right-0 top-0 mt-3 col-4" }, { children: _jsx("span", __assign({ className: "input-group-text border-0", onClick: function () { return setSeePassword(!seePassword); } }, { children: _jsx(FontAwesomeIcon, { fixedWidth: true, icon: seePassword ? faEyeSlash : faEye }) })) })))] })), !rolloutNewPasswordFieldFlag && (_jsx("div", __assign({ className: "form-group row flex-center" }, { children: _jsx("input", { type: "password", name: "resetting_form[plainPassword][second]", placeholder: "Confirm password", onChange: function (e) { return setConfirmPassword(e.target.value); }, required: true, className: "col-8 form-control h-auto form-control-solid py-4 px-8", autoComplete: "new-password" }) }))), errors && (_jsx("ul", __assign({ className: "list-unstyled" }, { children: errors.map(function (error) { return (_jsx("li", __assign({ className: "text-danger" }, { children: error }), error)); }) }))), _jsx("div", __assign({ className: "row flex-center" }, { children: renderPasswordRequirements() })), _jsx("div", { children: _jsx(Button, __assign({ buttonType: "primary", type: "submit", id: "resetting_form_save", className: "btn btn-primary", name: "resetting_form[save]", disabled: submitting || !validForm }, { children: submitting ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "spinner-border spinner-border-sm", role: "status", "aria-hidden": "true" }), _jsx("span", __assign({ className: "ml-1" }, { children: "Resetting..." }))] })) : (_jsx("span", { children: "Reset Password" })) })) }), _jsx("input", { type: "hidden", name: "resetting_form[_token]", value: csrfToken })] })) })) })));
    };
    var renderResetSuccess = function () {
        return (_jsxs("div", __assign({ className: "" }, { children: [_jsx("p", { children: "Password successfully reset." }), _jsx("a", __assign({ href: "/login", className: "btn btn-sm btn-primary mx-auto mt-5" }, { children: "Back to Login page" }))] })));
    };
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "d-flex flex-center flex-row-fluid bgi-size-cover bgi-position-top bgi-no-repeat", style: { backgroundImage: "url('/assets/media/bg/bg-3.jpg')" } }, { children: _jsxs("div", __assign({ className: "login-form text-center p-7 position-relative overflow-hidden" }, { children: [renderHeader(), resetSuccessful ? renderResetSuccess() : renderForm()] })) })) }));
};
// This element is mostly styled with the bootstrap classes
// but we need to override the hover cursor
var ShowPasswordDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  :hover {\n    cursor: pointer;\n  }\n"], ["\n  :hover {\n    cursor: pointer;\n  }\n"])));
var templateObject_1;
